<template>
    <div
      class="wf-masonry"
      :class="itemClasses"
      style="height: 100vw;"
    >
      <div
        v-for="item in items"
        :key="item.id"
        :class="classes"
      >
        <img
          class="wf-h-auto"
          :class="contentClasses"
          :src="item.url"
          :alt="item.alt"
        />
      </div>
    </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: [Array, Object],
        default: () => []
      },
      classes: {
        type: [Array, Object],
        default: () => []
      },
      itemClasses: {
        type: Array,
        default: () => []
      },
      contentClasses: {
        type: Array,
        default: () => []
      }
    }
  }
</script>
